<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-lg-6 col-12">
        <h3 class="text-start">Employees</h3>
      </div>
      <div class="col-lg-6 col-12 alignRight">
        <div class="row  justify-content-end">
          <div class="col-lg-4 col-12">
            <button style="width: 100%" mat-raised-button class="btn-set-color" (click)="fileUpload.click()">Upload Crew File
            </button>
            <input #fileUpload class="kw-primary-button-full" style="display: none;" type="file" id="file-upload" name="file-upload"
            (change)="onFileSelected($event)" multiple />
          </div>
          <!-- <div class="col-lg-4 col-12">
            <button style="width: 100%" mat-raised-button class="addButton" (click)="createEmployee();">Create Employee
            </button>
          </div> -->
        </div>

      </div>
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="this.isLoading">
    <ejs-grid #grid [dataSource]="this.dataSource" [allowPaging]="true" [enableHover]="false" [allowSelection]="true"
      [pageSettings]="this.pageSettings" [allowSorting]="true" [filterSettings]='this.filterSettings'
      [allowTextWrap]='true' [allowFiltering]="true" [enableStickyHeader]='true' height="600" [columns]="this.columns">
    </ejs-grid>
  </nb-card-body>
</nb-card>

<ng-template #actionTemplate let-data>
  <button mat-icon-button (click)="openDialog(data);">
    <fa-icon style="cursor: pointer;" size="lg" [icon]="faEdit"></fa-icon>
  </button>
</ng-template>

<ng-template let-data2 #activeTemplate>
  <div *ngIf="data2.isActive" style="color:green">
    <fa-icon size="lg" [icon]="faCheck"></fa-icon>
  </div>
  <div *ngIf="!data2.isActive" style="color:
  red">
    <fa-icon size="lg" [icon]="faTimes"></fa-icon>
  </div>
</ng-template>

<ng-template let-data2 #hourlyTemplate>
  <div *ngIf="data2.isHourly" style="color:green">
    <fa-icon size="lg" [icon]="faCheck"></fa-icon>
  </div>
  <div *ngIf="!data2.isHourly" style="color:
  red">
    <fa-icon size="lg" [icon]="faTimes"></fa-icon>
  </div>
</ng-template>